type IconType =  
'SHOW-MORE' 
| 'SHOW-LESS'

type Color = 'orange' | 'blue' | 'gray'

interface Props {
    icon: IconType
    color?: Color
    onClick?: Function
}

const IconButton = ({ icon, color='blue', onClick }: Props) => {
    const handleClick = () => {
        if(onClick){
            onClick()
        }
    }
    
    let backgroundColor
    switch(color){
        case 'orange':
            backgroundColor = '#FFAC33'
            break
        case 'gray':
            backgroundColor = '#d7d7d7'
            break
        default:
            backgroundColor = '#265EF6'
            break
    }
    return(
        <div className="icon-button" style={{backgroundColor}} onClick={handleClick}>
            { icon === 'SHOW-MORE' && <img className="icon-button__img" src="/images/icons/plus-icon.svg" alt="show more"/> }
            { icon === 'SHOW-LESS' && <img className="icon-button__img" src="/images/icons/less-icon.svg" alt="show less"/> }
        </div>
    )
}

export default IconButton